<div id="orManagingCompanyUsersTable">
  <mat-table [dataSource]="dataSource" class="users-table mat-elevation-z8" matSort [matSortDisableClear]="true">

    <ng-container matColumnDef="buildingName">
      <mat-header-cell *matHeaderCellDef mat-sort-header start="asc">Building</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.buildingName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="userID">
      <mat-header-cell *matHeaderCellDef>User ID</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.id }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="emailAddress">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.emailAddress }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastLoggedIn">
      <mat-header-cell *matHeaderCellDef>Last Login</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ formatLastLoggedIn(data.lastLoggedIn) }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="authMethod">
      <mat-header-cell *matHeaderCellDef>Auth</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.authMethod }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="authSource">
      <mat-header-cell *matHeaderCellDef>Auth Source</mat-header-cell>
      <mat-cell *matCellDef="let data">{{ data.authSource }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell class="actions-cell" *matCellDef="let data">
        <button mat-mini-fab type="button" (click)="onEdit(data)" aria-label="Edit user authorities">
          <mat-icon>edit</mat-icon>
        </button>

        <button
          mat-mini-fab
          color="warn"
          type="button"
          (click)="onDelete(data)"
          aria-label="Delete user from this building"
          [disabled]="checkIfMCAdminAndNotInBuilding(data)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

  <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
</div>
